import "./styles.css";
import { PiTargetBold } from "react-icons/pi";
import { useTheme, useMediaQuery } from "@mui/material";

export function Exercicios({
  concluido,
  nota,
  podeResponder,
  onResponder,
  dataLimite,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      className="exercicio_area"
      style={{ width: isMobile ? "50%" : "100%" }}
    >
      <h1>Exercícios</h1>
      <div
        className="exercicio-container"
        style={{ width: isMobile ? "180px" : "220px" }}
      >
        <div className="exercicio-icon">
          <PiTargetBold size={32} color="#555" />
        </div>
        <h4 className="exercicio-titulo">Questionário 01</h4>
        <p className="exercicio-subtitulo">Avaliação de módulo</p>
        {dataLimite && (
          <p className="exercicio-data">Realizar até {dataLimite}</p>
        )}
        <button
          className={`exercicio-botao`}
          disabled={!podeResponder}
          onClick={onResponder}
        >
          {concluido ? `${nota}/10` : "Responder"}
        </button>
      </div>
    </div>
  );
}
